module.exports = __webpack_public_path__ + "static/media/inf_88og89.72c022d3.mp3";